import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { id: "mainContent" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    class: "collapse mb-3",
    id: "selectionFilter"
};
const _hoisted_4 = { class: "row g-3" };
const _hoisted_5 = {
    key: 0,
    class: "col-12 col-md-6 col-lg-4"
};
const _hoisted_6 = {
    key: 1,
    class: "col-12 col-md-6 col-lg-4"
};
const _hoisted_7 = {
    key: 2,
    class: "col-12 col-md-6 col-lg-4"
};
const _hoisted_8 = {
    key: 3,
    class: "col-12 col-md-6 col-lg-4"
};
const _hoisted_9 = {
    key: 4,
    class: "col-12 col-md-6 col-lg-4"
};
const _hoisted_10 = {
    key: 1,
    class: "pt-3"
};
const _hoisted_11 = {
    key: 0,
    class: "row row-cols-1 row-cols-md-2 row-cols-xl-4 g-4"
};
const _hoisted_12 = { class: "col position-relative" };
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
    class: "w-100 bg-white py-3",
    style: { "height": "300px" }
};
const _hoisted_15 = ["src"];
const _hoisted_16 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_17 = { class: "text-center fw-bold" };
const _hoisted_18 = {
    key: 0,
    class: "text-center fw-bold small"
};
const _hoisted_19 = { class: "text-center" };
const _hoisted_20 = { key: 1 };
const _hoisted_21 = { class: "m-2" };
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
    class: "w-100 bg-white py-3",
    style: { "height": "300px" }
};
const _hoisted_24 = ["src"];
const _hoisted_25 = { class: "p-2 d-flex flex-column justify-content-center" };
const _hoisted_26 = { class: "text-center fw-bold" };
const _hoisted_27 = {
    key: 0,
    class: "text-center fw-bold small"
};
const _hoisted_28 = { class: "text-center" };
const _hoisted_29 = {
    key: 2,
    class: "d-flex justify-content-center align-items-center flex-column"
};
const _hoisted_30 = { class: "fw-bold text-primary" };
const _hoisted_31 = {
    key: 0,
    id: "contextModal"
};
const _hoisted_32 = { class: "d-block d-md-flex justify-content-between align-items-center mb-3" };
const _hoisted_33 = { class: "me-0 me-lg-5" };
const _hoisted_34 = { class: "fw-bold mb-3 gallery-font-color" };
const _hoisted_35 = {
    key: 0,
    class: "bg-light rounded p-3"
};
const _hoisted_36 = { class: "row row-cols-1 row-cols-md-2 g-3" };
const _hoisted_37 = {
    key: 0,
    class: "col"
};
const _hoisted_38 = { class: "fw-bold gallery-font-color" };
const _hoisted_39 = { class: "m-0" };
const _hoisted_40 = {
    key: 1,
    class: "col"
};
const _hoisted_41 = { class: "fw-bold gallery-font-color" };
const _hoisted_42 = { class: "m-0" };
const _hoisted_43 = {
    key: 2,
    class: "col"
};
const _hoisted_44 = { class: "fw-bold gallery-font-color" };
const _hoisted_45 = { class: "m-0" };
const _hoisted_46 = {
    key: 3,
    class: "col"
};
const _hoisted_47 = { class: "fw-bold gallery-font-color" };
const _hoisted_48 = { class: "m-0" };
const _hoisted_49 = {
    key: 4,
    class: "col"
};
const _hoisted_50 = { class: "fw-bold gallery-font-color" };
const _hoisted_51 = { class: "m-0" };
const _hoisted_52 = { class: "d-flex justify-content-center" };
const _hoisted_53 = { class: "text-center" };
const _hoisted_54 = {
    class: "d-flex align-items-center justify-content-center",
    style: { "height": "300px" }
};
const _hoisted_55 = ["src"];
const _hoisted_56 = { class: "d-flex align-items-center justify-content-center h-100" };
const _hoisted_57 = ["src", "onClick"];
const _hoisted_58 = { class: "d-flex justify-content-center" };
const _hoisted_59 = ["href"];
const _hoisted_60 = { class: "ms-2" };
const _hoisted_61 = { class: "ms-2" };
const _hoisted_62 = ["innerHTML"];
const _hoisted_63 = {
    key: 0,
    class: "mt-5 small"
};
import axios from 'axios';
import { onMounted, ref, watch } from 'vue';
import { observeDOMChanges, sendHeight } from '../Composables/iframeHeightCalculator';
import { cssStyleSheetLoader } from '../Composables/cssStyleSheetLoader';
import ConfiguratorLayout from '../Layouts/ConfiguratorLayout.vue';
import { usePage } from '@inertiajs/vue3';
import { filters } from '../Composables/filters';
import { Carousel, MultiSelect, Select } from 'primevue';
import ContextModal from '../Components/ContextModal.vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { useI18n } from 'vue-i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductGallery',
    props: {
        configuratorUrl: String,
        componentUuid: {
            type: String,
            required: true
        },
        tenantId: {
            type: String,
            required: true
        },
        cssFileUrl: {
            type: String,
            default: null
        },
        sessionId: String,
        showFilters: Boolean,
        sliderView: Boolean,
        publicFilters: {
            type: Array,
            default: () => []
        }
    },
    setup(__props) {
        let { loadCssStyleSheet } = cssStyleSheetLoader();
        let { formatCurrency } = formatters();
        let { showSuccessSwal } = responseMessages();
        const { t } = useI18n();
        const { productCategories, selectedProductCategories, materials, selectedMaterials, volumes, selectedVolumes, bottleHeights, selectedBottleHeights, sodaStreamOptions, selectedSodaStreamOption, loadFilters, searchBottles, searchAccessoryProducts } = filters();
        const props = __props;
        const page = usePage();
        const user = page.props.auth.user;
        const availablePublicFilters = page.props.iframes.publicFilters;
        const searchString = ref('');
        const loading = ref(false);
        const products = ref([]);
        const detailsProduct = ref(null);
        const modal = ref();
        const responsiveOptions = ref([
            {
                breakpoint: '1400px',
                numVisible: 3,
                numScroll: 1
            },
            {
                breakpoint: '1000px',
                numVisible: 2,
                numScroll: 1
            },
            {
                breakpoint: '750px',
                numVisible: 1,
                numScroll: 1
            }
        ]);
        onMounted(() => {
            if (props.cssFileUrl) {
                loadCssStyleSheet(props.cssFileUrl);
            }
            loadFilters(props.tenantId);
            search();
            sendHeight();
            observeDOMChanges();
        });
        watch([
            selectedProductCategories,
            selectedMaterials,
            selectedVolumes,
            selectedBottleHeights,
            selectedSodaStreamOption
        ], () => {
            search();
        });
        async function search() {
            loading.value = true;
            try {
                products.value = await searchBottles(props.tenantId, selectedProductCategories.value, selectedMaterials.value, selectedVolumes.value, selectedBottleHeights.value, selectedSodaStreamOption.value, props.componentUuid);
                products.value = products.value.concat(await searchAccessoryProducts(props.tenantId, selectedProductCategories.value, selectedMaterials.value, props.componentUuid));
            }
            catch (error) {
                console.log(error);
                loading.value = false;
            }
            finally {
                loading.value = false;
            }
        }
        function showProductDetails(product, event) {
            let routeName = product.volume ? 'configurator.bottles.selection.details.show' : 'configurator.accessoryProducts.selection.details.show';
            axios.post(route(routeName, product.id), {})
                .then(function (response) {
                detailsProduct.value = response.data;
                modal.value.open(event);
            })
                .catch(function (error) {
                console.log(error);
                detailsProduct.value = null;
            });
        }
        function addToCart(productId) {
            axios.post(route('cart.products.store', productId), {})
                .then(function (response) {
                showSuccessSwal('Produkt wurde in den Warenkorb gelegt');
            })
                .catch(function (error) {
                console.error(error);
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ConfiguratorLayout, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (props.showFilters)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _cache[6] || (_cache[6] = _createElementVNode("button", {
                                    class: "btn btn-secondary d-inline-flex align-items-center mb-3",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": "#selectionFilter"
                                }, [
                                    _createElementVNode("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        height: "20",
                                        fill: "currentColor",
                                        class: "bi bi-sliders",
                                        viewBox: "0 0 16 16"
                                    }, [
                                        _createElementVNode("path", {
                                            "fill-rule": "evenodd",
                                            d: "M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1z"
                                        })
                                    ])
                                ], -1)),
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        (props.publicFilters.length == 0 || props.publicFilters.includes(_unref(availablePublicFilters)['product_categories']))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: _unref(selectedProductCategories),
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(selectedProductCategories) ? (selectedProductCategories).value = $event : null)),
                                                    options: _unref(productCategories),
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: _unref(t)('Produktkategorien')
                                                }, null, 8, ["modelValue", "options", "placeholder"])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (props.publicFilters.length == 0 || props.publicFilters.includes(_unref(availablePublicFilters)['materials']))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: _unref(selectedMaterials),
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(selectedMaterials) ? (selectedMaterials).value = $event : null)),
                                                    options: _unref(materials),
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "uuid",
                                                    placeholder: _unref(t)('Materialien')
                                                }, null, 8, ["modelValue", "options", "placeholder"])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (props.publicFilters.length == 0 || props.publicFilters.includes(_unref(availablePublicFilters)['volumes']))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: _unref(selectedVolumes),
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(selectedVolumes) ? (selectedVolumes).value = $event : null)),
                                                    options: _unref(volumes),
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "value",
                                                    placeholder: _unref(t)('Fassungsvermögen')
                                                }, null, 8, ["modelValue", "options", "placeholder"])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (props.publicFilters.length == 0 || props.publicFilters.includes(_unref(availablePublicFilters)['heights']))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                _createVNode(_unref(MultiSelect), {
                                                    class: "w-100",
                                                    modelValue: _unref(selectedBottleHeights),
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (_isRef(selectedBottleHeights) ? (selectedBottleHeights).value = $event : null)),
                                                    options: _unref(bottleHeights),
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "value",
                                                    placeholder: _unref(t)('Höhe')
                                                }, null, 8, ["modelValue", "options", "placeholder"])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (props.publicFilters.length == 0 || props.publicFilters.includes(_unref(availablePublicFilters)['soda_stream']))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                _createVNode(_unref(Select), {
                                                    class: "w-100",
                                                    modelValue: _unref(selectedSodaStreamOption),
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_isRef(selectedSodaStreamOption) ? (selectedSodaStreamOption).value = $event : null)),
                                                    options: _unref(sodaStreamOptions),
                                                    filter: "",
                                                    optionLabel: "name",
                                                    optionValue: "value",
                                                    placeholder: _unref(t)('Soda-Stream-Eignung')
                                                }, null, 8, ["modelValue", "options", "placeholder"])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (!loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                (!__props.sliderView)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
                                            return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                _createElementVNode("button", {
                                                    class: "btn bg-light border border-2 rounded-3 p-0 w-100",
                                                    style: { "overflow": "hidden" },
                                                    onClick: ($event) => (showProductDetails(product, $event))
                                                }, [
                                                    _createElementVNode("div", _hoisted_14, [
                                                        _createElementVNode("img", {
                                                            src: product.image,
                                                            class: "h-100"
                                                        }, null, 8, _hoisted_15)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_16, [
                                                        _createElementVNode("span", _hoisted_17, _toDisplayString(product.name), 1),
                                                        (product.volume)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(product.volume), 1))
                                                            : _createCommentVNode("", true),
                                                        _createElementVNode("span", _hoisted_19, "ab " + _toDisplayString(_unref(formatCurrency)(product.startPrice)), 1)
                                                    ])
                                                ], 8, _hoisted_13)
                                            ]));
                                        }), 256))
                                    ]))
                                    : _createCommentVNode("", true),
                                (__props.sliderView)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createVNode(_unref(Carousel), {
                                            value: products.value,
                                            numVisible: 4,
                                            numScroll: 1,
                                            responsiveOptions: responsiveOptions.value,
                                            showIndicators: false,
                                            showNavigators: true
                                        }, {
                                            item: _withCtx((slotProps) => [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _createElementVNode("button", {
                                                        class: "btn bg-light border border-2 rounded-3 p-0 w-100 gallery-btn",
                                                        style: { "overflow": "hidden" },
                                                        onClick: ($event) => (showProductDetails(slotProps.data, $event))
                                                    }, [
                                                        _createElementVNode("div", _hoisted_23, [
                                                            _createElementVNode("img", {
                                                                src: slotProps.data.image,
                                                                class: "h-100"
                                                            }, null, 8, _hoisted_24)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_25, [
                                                            _createElementVNode("span", _hoisted_26, _toDisplayString(slotProps.data.name), 1),
                                                            (slotProps.data.volume)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(slotProps.data.volume), 1))
                                                                : _createCommentVNode("", true),
                                                            _createElementVNode("span", _hoisted_28, "ab " + _toDisplayString(_unref(formatCurrency)(slotProps.data.startPrice)), 1)
                                                        ])
                                                    ], 8, _hoisted_22)
                                                ])
                                            ]),
                                            _: 1
                                        }, 8, ["value", "responsiveOptions"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _cache[7] || (_cache[7] = _createElementVNode("div", {
                                    class: "spinner-grow text-primary mb-3",
                                    role: "status",
                                    style: { "width": "3rem", "height": "3rem" }
                                }, [
                                    _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                                ], -1)),
                                _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('Auswahl wird geladen')), 1)
                            ]))
                    ]),
                    _createVNode(ContextModal, {
                        ref_key: "modal",
                        ref: modal
                    }, {
                        default: _withCtx(() => [
                            (detailsProduct.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, [
                                            _createElementVNode("h3", _hoisted_34, _toDisplayString(detailsProduct.value.name), 1),
                                            (detailsProduct.value.volume || detailsProduct.value.height || detailsProduct.value.diameter || detailsProduct.value.material || detailsProduct.value.printAreas)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                                    _createElementVNode("div", _hoisted_36, [
                                                        (detailsProduct.value.volume)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                                _createElementVNode("h6", _hoisted_38, _toDisplayString(_unref(t)('Volumen')), 1),
                                                                _createElementVNode("p", _hoisted_39, _toDisplayString(detailsProduct.value.volume), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (detailsProduct.value.height)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                                _createElementVNode("h6", _hoisted_41, _toDisplayString(_unref(t)('Höhe')), 1),
                                                                _createElementVNode("p", _hoisted_42, _toDisplayString(detailsProduct.value.height) + " mm", 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (detailsProduct.value.diameter)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                                _createElementVNode("h6", _hoisted_44, _toDisplayString(_unref(t)('Durchmesser')), 1),
                                                                _createElementVNode("p", _hoisted_45, _toDisplayString(detailsProduct.value.diameter) + " mm", 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (detailsProduct.value.material)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                                _createElementVNode("h6", _hoisted_47, _toDisplayString(_unref(t)('Material')), 1),
                                                                _createElementVNode("p", _hoisted_48, _toDisplayString(detailsProduct.value.material), 1)
                                                            ]))
                                                            : _createCommentVNode("", true),
                                                        (detailsProduct.value.printAreas)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                                _createElementVNode("h6", _hoisted_50, _toDisplayString(_unref(t)('Druckbereiche (Breite x Höhe)')), 1),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailsProduct.value.printAreas, (printArea) => {
                                                                    return (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(printArea.width) + " mm x " + _toDisplayString(printArea.height) + " mm", 1));
                                                                }), 256))
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_52, [
                                            _createElementVNode("div", _hoisted_53, [
                                                _createElementVNode("div", _hoisted_54, [
                                                    _createElementVNode("img", {
                                                        src: detailsProduct.value.image,
                                                        class: "img-fluid rounded",
                                                        style: { "max-height": "300px", "max-width": "300px" }
                                                    }, null, 8, _hoisted_55)
                                                ]),
                                                _createVNode(_unref(Carousel), {
                                                    value: detailsProduct.value.images,
                                                    numVisible: 3,
                                                    numScroll: 1,
                                                    responsiveOptions: responsiveOptions.value,
                                                    showIndicators: false,
                                                    showNavigators: true,
                                                    class: "w-100 mt-3"
                                                }, {
                                                    item: _withCtx((slotProps) => [
                                                        _createElementVNode("div", _hoisted_56, [
                                                            _createElementVNode("img", {
                                                                src: slotProps.data,
                                                                class: "img-fluid rounded m-2",
                                                                style: { "max-height": "1000px", "max-width": "100px", "cursor": "pointer" },
                                                                onClick: ($event) => { detailsProduct.value.image = slotProps.data; }
                                                            }, null, 8, _hoisted_57)
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["value", "responsiveOptions"])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_58, [
                                        (detailsProduct.value.volume)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: props.configuratorUrl + '?bottleId=' + detailsProduct.value.id,
                                                target: "_top",
                                                class: "btn btn-primary d-inline-flex align-items-center m-3"
                                            }, [
                                                _cache[8] || (_cache[8] = _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-arrow-right",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", {
                                                        "fill-rule": "evenodd",
                                                        d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                                    })
                                                ], -1)),
                                                _createElementVNode("span", _hoisted_60, _toDisplayString(_unref(t)('Jetzt konfigurieren')), 1)
                                            ], 8, _hoisted_59))
                                            : _createCommentVNode("", true),
                                        (detailsProduct.value.volume == null)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                class: "btn btn-primary d-inline-flex align-items-center m-3",
                                                onClick: _cache[5] || (_cache[5] = ($event) => (addToCart(detailsProduct.value.id)))
                                            }, [
                                                _cache[9] || (_cache[9] = _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-arrow-right",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", {
                                                        "fill-rule": "evenodd",
                                                        d: "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                                                    })
                                                ], -1)),
                                                _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(t)('In den Warenkorb')), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", {
                                        innerHTML: detailsProduct.value.description,
                                        class: "mb-3"
                                    }, null, 8, _hoisted_62)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 512),
                    (_unref(user) && !_unref(user).isCustomer)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(props.sessionId), 1))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
